import axios from "axios";
import ApiService from "./Api";
// import ApiServiceNew from "./api.service";

import {
  GET_BOARDING_DROPPING_POINTS,
  GET_CARS,
  GET_CATEGORIES,
  GET_CATEGORIES_SEARCH_RIDE,
  GET_CATEGORIES_V1,
  GET_CITIES,
  GET_EDIT_CATEGORIES,
  GET_ESTIMATE_TRIP_FARE,
  GET_RAZORPAY_KEYS,
  GET_RAZORPAY_ORDER,
  GET_RAZORPAY_PAYMENT_VERIFY,
  GET_SEAT_AVAILABLE_CHECK,
  GET_TRIP_RAZORPAY_ORDER,
  GET_TRIPS,
  GET_USER,
  GET_VALIDATE_PROMO,
  SAVE_CATEGORIES,
  SAVE_MTRIP_CATEGORY,
  SAVE_TRANSACTION,
  SAVE_TRIP,
  SAVE_TRIP_NOTIFICATION_SEND,
  SAVE_TRIP_WITH_TRANS,
  UPDATE_CATEGORIES,
  UPDATE_TRIP,
  GET_RIDE_POSTS,
  GET_RIDE_BOARDING_DROPPING_POINTS,
  SAVE_RIDE_POSTS,
  UPDATE_RIDE_POSTS,
  GET_RIDE_POST_SEARCH_RIDE,
  GET_CATEGORIES_STOP_OVERS,
  GET_CATEGORY_TAGS,
  GET_CATEGORIES_STOPS,
  SAVE_TRANSACTION_V1
} from "./Endpoint";

// Boarding & Dropping Points
export const getBoardingDroppingPoints = (data, apiKey) => {
  return ApiService.post(
    `${GET_BOARDING_DROPPING_POINTS}?api_key=${apiKey}`,
    data
  );
};

// Get Category Data
export const getCategoryByData = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORIES}?api_key=${apiKey}`, data);
};

// Get Category Tags
export const getCategoryTags = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORY_TAGS}?api_key=${apiKey}`, data);
};

// Get Category Edit Data
export const getCategoryEditByData = (data, apiKey) => {
  return ApiService.post(`${GET_EDIT_CATEGORIES}?api_key=${apiKey}`, data);
};

// Get Category Data
export const getCategoryV1ByData = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORIES_V1}?api_key=${apiKey}`, data);
};

// Save Category
export const postSaveCategory = (data, apiKey) => {
  return ApiService.post(`${SAVE_CATEGORIES}?api_key=${apiKey}`, data);
};

// Update Category
export const postUpdateCategory = (data, apiKey) => {
  return ApiService.post(`${UPDATE_CATEGORIES}?api_key=${apiKey}`, data);
};

// Get Category Stops Overs
export const getCategoryStopOvers = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORIES_STOP_OVERS}?api_key=${apiKey}`, data);
};

// Get Category Stops
export const getCategoryStops = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORIES_STOPS}?api_key=${apiKey}`, data);
};

// Get Cars
export const getCars = (data, apiKey) => {
  return ApiService.post(`${GET_CARS}?api_key=${apiKey}`, data);
};

// Get Category Search Ride Data
export const getCategorySearchRide = (data, apiKey) => {
  return ApiService.post(`${GET_CATEGORIES_SEARCH_RIDE}?api_key=${apiKey}`, data);
};

// Get Estimate Fare
export const getEstimateFareByData = (data, apiKey) => {
  return ApiService.post(`${GET_ESTIMATE_TRIP_FARE}?api_key=${apiKey}`, data);
};

// Create Trip
export const postSaveTrip = (data, apiKey) => {
  return ApiService.post(`${SAVE_TRIP}?api_key=${apiKey}`, data);
};

// Create Trip With Trans
export const postSaveTripWithTrans = (data, apiKey) => {
  return ApiService.post(`${SAVE_TRIP_WITH_TRANS}?api_key=${apiKey}`, data);
};

// Validate Promo
export const validatePromoCode = (data, apiKey) => {
  return ApiService.post(`${GET_VALIDATE_PROMO}?api_key=${apiKey}`, data);
};

// Razorpay Order Craete
export const postRazorpayOrderCreate = (data, apiKey) => {
  return ApiService.post(`${GET_RAZORPAY_ORDER}?api_key=${apiKey}`, data);
};

// Razorpay Order Trip
export const postRazorpayTripOrderCreate = (data, apiKey) => {
  return ApiService.post(`${GET_TRIP_RAZORPAY_ORDER}?api_key=${apiKey}`, data);
};

// Razorpay Payment Verify
export const postRazorpayPaymentVerify = (data, apiKey) => {
  return ApiService.post(
    `${GET_RAZORPAY_PAYMENT_VERIFY}?api_key=${apiKey}`,
    data
  );
};

// Razorpay
export const getRazorpayKeyData = (data, apiKey) => {
  return ApiService.post(`${GET_RAZORPAY_KEYS}?api_key=${apiKey}`, data);
};

// post Save Payment
export const postSaveTransaction = (data, apiKey) => {
  return ApiService.post(`${SAVE_TRANSACTION}?api_key=${apiKey}`, data);
};

// post Save Payment V!
export const postSaveTransactionv1 = (data, apiKey) => {
  return ApiService.post(`${SAVE_TRANSACTION_V1}?api_key=${apiKey}`, data);
};

// Send NotificationOnTripSave
export const sendNotificationOnTripSave = (data, apiKey) => {
  return ApiService.post(
    `${SAVE_TRIP_NOTIFICATION_SEND}?api_key=${apiKey}`,
    data
  );
};

// Check Seat Avaible By Category Seat and Travel Date
export const checkSeatAvailabilityCategory = (data, apiKey) => {
  return ApiService.post(`${GET_SEAT_AVAILABLE_CHECK}?api_key=${apiKey}`, data);
};

export const getCityData = (data, apiKey) => {
  return ApiService.post(`${GET_CITIES}?api_key=${apiKey}`, data);
};

export const getUserDetail = (data, apiKey) => {
  return ApiService.post(`${GET_USER}?api_key=${apiKey}`, data);
};

// Post Save MTrip
export const postSaveMTripCategory = (data, apiKey) => {
  return ApiService.post(`${SAVE_MTRIP_CATEGORY}?api_key=${apiKey}`, data);
};

export const getTripDetail = (data, apiKey) => {
  return ApiService.post(`${GET_TRIPS}?api_key=${apiKey}`, data);
};

// Update Trip
export const postUpdateTrip = (data, apiKey) => {
  return ApiService.post(`${UPDATE_TRIP}?api_key=${apiKey}`, data);
};

// Boarding & Dropping Points Ride Posts
export const getRidePostBoardingDroppingPoints = (data, apiKey) => {
  return ApiService.post(
    `${GET_RIDE_BOARDING_DROPPING_POINTS}?api_key=${apiKey}`,
    data
  );
};

// Get Ride Posts Data
export const getRidePostByData = (data, apiKey) => {
  return ApiService.post(`${GET_RIDE_POSTS}?api_key=${apiKey}`, data);
};

// Save RidePosts
export const postSaveRidePosts = (data, apiKey) => {
  return ApiService.post(`${SAVE_RIDE_POSTS}?api_key=${apiKey}`, data);
};

// Update RidePosts
export const postUpdateRidePosts = (data, apiKey) => {
  return ApiService.post(`${UPDATE_RIDE_POSTS}?api_key=${apiKey}`, data);
};

// Get Ride Posts Search 
export const getRidePostSearchRide = (data, apiKey) => {
  return ApiService.post(`${GET_RIDE_POST_SEARCH_RIDE}?api_key=${apiKey}`, data);
};

// Send Booking SMS
export const sendBookingSMS = (data) => {
  return axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/booking_sms`,
      data,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    );
};